import React, { lazy, Suspense } from "react";
import {
  TopToolbar,
  CreateButton,
  useListContext,
  FilterButton,
} from "react-admin";

import { READY_TO_SHIP_ORDERS } from "../components/Constant";
import { useProfileParams } from "../components/useProfileParams";
import {
  useMaxResultsByPlan,
  useIsEnterprisePlan,
} from "../helpers/subscriptionPlan";

import ListSelectableFields from "./ListSelectable";
import ExportButtonBatchJob from "./ExportButtonBatchJob";

// Lazy loaded components
const MillionExportButton = lazy(() => import("./MillionExporter"));
const RZYExportButton = lazy(() => import("./RZYExporter"));
const MFBEasyParcelExportButton = lazy(() => import("./MFBEasyParcelExporter"));
const OasisAutoCountExportButton = lazy(() =>
  import("./OasisAutoCountExporter")
);

const SuspenseWrapper = ({ children }) => (
  <Suspense fallback={"Loading..."}>{children}</Suspense>
);

const ListActions = (props) => {
  const { filter } = props;
  const { total, sort, filterValues, resource } = useListContext();
  const currentPath = window.location.hash;
  const isCanCreate =
    currentPath.includes("/orders") || currentPath.includes("/activeorders");
  const isAllOrders = currentPath.includes("/orders");
  const isReadyToShip = currentPath.includes(`/${READY_TO_SHIP_ORDERS}`);
  const [params] = useProfileParams();
  const {
    enableMillionExport = false,
    enableOasisAutocountExport = false,
    enableRZYExport = false,
    enableMFBEasyParcel = false,
  } = params;
  const maxResults = useMaxResultsByPlan();
  const isEnterprisePlan = useIsEnterprisePlan();

  return (
    <TopToolbar>
      <FilterButton />
      {isCanCreate && <CreateButton />}

      <ExportButtonBatchJob
        disabled={total === 0}
        resource={resource}
        sort={sort}
        filter={{ ...filterValues, ...filter }}
      />

      {isAllOrders && enableMillionExport && isEnterprisePlan && (
        <SuspenseWrapper>
          <MillionExportButton
            disabled={total === 0}
            resource={resource}
            sort={sort}
            label="Million"
            maxResults={maxResults}
          />
        </SuspenseWrapper>
      )}

      {(isReadyToShip || isAllOrders) && enableRZYExport && isEnterprisePlan && (
        <SuspenseWrapper>
          <RZYExportButton
            disabled={total === 0}
            resource={resource}
            sort={sort}
            filter={{ ...filterValues, ...filter }}
            label="RZY"
            maxResults={maxResults}
          />
        </SuspenseWrapper>
      )}

      {(isReadyToShip || isAllOrders) &&
        enableMFBEasyParcel &&
        isEnterprisePlan && (
          <SuspenseWrapper>
            <MFBEasyParcelExportButton
              disabled={total === 0}
              resource={resource}
              sort={sort}
              filter={{ ...filterValues, ...filter }}
              label="EasyParcel"
              maxResults={maxResults}
            />
          </SuspenseWrapper>
        )}

      {isAllOrders && enableOasisAutocountExport && isEnterprisePlan && (
        <SuspenseWrapper>
          <OasisAutoCountExportButton
            disabled={total === 0}
            resource={resource}
            sort={sort}
            label="AutoCount"
            maxResults={maxResults}
          />
        </SuspenseWrapper>
      )}

      <ListSelectableFields />
    </TopToolbar>
  );
};

ListActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default ListActions;
